import { render, staticRenderFns } from "./PremiumPayForm.vue?vue&type=template&id=2ef993c1&scoped=true&"
import script from "./PremiumPayForm.vue?vue&type=script&lang=js&"
export * from "./PremiumPayForm.vue?vue&type=script&lang=js&"
import style0 from "./PremiumPayForm.vue?vue&type=style&index=0&id=2ef993c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef993c1",
  null
  
)

export default component.exports